export default "__VITE_ASSET__qco4FrRa__"